// extracted by mini-css-extract-plugin
module.exports = {"item":"item_item__I0TmM","item_detail__customize_button":"item_item_detail__customize_button__cUM_u"};